import { useEffect, useState } from "react";
import DropDownInput from "../../../helperComponents/DropDownInput";
import { serverLine } from "../../../../controllers/network/serverLine";
import onChangePermissionGuard from "../../../../controllers/customControllerForCS/onChangePermissionGuard";
import isFieldViewPermissionAllowed from "../../../../controllers/customControllerForCS/isFieldViewPermissionAllowed";

export default function RoleDropDownInput({
  onChange,
  label,
  value,
  style,
  permissionName,
}) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    loadItems();
  }, []);

  onChange = onChangePermissionGuard({ onChange, permissionName });
  let viewAllowed = isFieldViewPermissionAllowed({ permissionName });
  if (!viewAllowed) return false;

  if (!items) return null;

  let options = items.map((item) => {
    return { value: item._id, label: item.name };
  });

  return (
    <DropDownInput
      style={style}
      value={value}
      label={label}
      onChange={onChange}
      options={options}
    />
  );

  function loadItems() {
    serverLine.get("/roles").then((data) => {
      setItems(data.list);
    });
  }
}
